import { Captura, Section } from "./comunes";

export default function AyudaNotificaciones() {
  return (
    <>
      <Section id="notificaciones" title="Notificaciones — cómo te avisa el sistema">
        <p>
          Eventos que generan aviso: <strong>te asignaron un caso</strong>,{" "}
          <strong>llegó respuesta</strong> a un caso tuyo, <strong>te pasaron
          un caso</strong> (handoff), un caso <strong>cruzó el umbral</strong>{" "}
          de inactividad, <strong>cerraron un caso que abriste</strong> y tus{" "}
          <strong>recordatorios</strong>, y{" "}
          <strong>correos de tu buzón que parecen solicitudes</strong>. Tú eliges{" "}
          <strong>por qué canales</strong> recibirlos en{" "}
          <strong>Perfil → Notificaciones</strong> (la campana de Alertas
          siempre los recibe):
        </p>
        <p className="mt-2">
          En la página <strong>Alertas</strong> se agrupan por urgencia:{" "}
          <strong>🔴 Atiende ya</strong> (escalaciones, casos quemados),{" "}
          <strong>🟡 Pendientes</strong> (por quemarse, recordatorios,
          asignaciones, menciones, correo nuevo, buzón) y{" "}
          <strong>⚪ Para enterarte</strong> (cierres, avisos de sistema).
          Cada tipo trae su propio ícono y color. Los filtros{" "}
          <strong>Solo míos</strong>, <strong>No leídas</strong> y por{" "}
          <strong>tipo</strong> (chips) acotan la lista; "Marcar todas" existe
          por grupo y para toda la bandeja.
        </p>
        <Captura
          src="/ayuda-img/alertas.png"
          alt="Bandeja de Alertas agrupada por urgencia"
          caption="Alertas: grupo 🔴 Atiende ya arriba de todo, con los chips de filtro por tipo (ícono + color) y los toggles Solo míos / No leídas."
        />
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>
            <strong>En la app (campana de Alertas)</strong>: siempre activa, el
            canal base. <strong>No se puede apagar</strong> — todo aviso llega
            aquí.
          </li>
          <li>
            <strong>Navegador (push)</strong>: avisos en tu pantalla aunque la
            app esté cerrada. Préndelo o apágalo en{" "}
            <strong>Perfil → Notificaciones</strong>, y da de alta cada equipo
            en esa misma sección (botón "Activar en este dispositivo" + prueba).
          </li>
          <li>
            <strong>Telegram</strong>: vincula tu cuenta en Perfil → Telegram
            (un toque, sin teclear nada); el interruptor para prenderlo o
            apagarlo como canal está en <strong>Perfil → Notificaciones</strong>.
          </li>
          <li>
            <strong>Correo</strong>: recordatorios, resumen diario y pases de
            caso llegan también a tu correo. Si no los quieres por mail, apágalo
            en <strong>Perfil → Notificaciones</strong>.
          </li>
        </ul>
        <Captura
          src="/ayuda-img/perfil.png"
          alt="Perfil con notificaciones y Telegram"
          caption="Perfil → Notificaciones: elige por dónde recibir (campanita siempre activa; navegador, Telegram y correo apagables), da de alta tus dispositivos y define el horario de silencio."
        />
        <p className="text-zinc-400">
          Los toggles de "Recibir avisos" silencian un canal{" "}
          <strong>sin desuscribir ni desvincular</strong> — al reactivarlos
          todo vuelve a sonar.
        </p>

        <div className="border-t border-ink-700 mt-3 pt-3">
          <p>
            <strong>Ruteo por nivel de urgencia:</strong> cada aviso nace con
            una urgencia de fábrica — <strong>🔴 Atiende ya</strong> (mención,
            escalación, caso quemado, recordatorio), <strong>🟡 Pendientes</strong>{" "}
            (asignación, correo nuevo, por quemarse) o{" "}
            <strong>⚪ Para enterarte</strong> (cierre, avisos de sistema). En{" "}
            <strong>Perfil → Notificaciones</strong>, la sección{" "}
            <strong>Ruteo por nivel de urgencia</strong> decide, para cada
            nivel, si además de la campanita también suena tu{" "}
            <strong>navegador</strong> y/o <strong>Telegram</strong>. De
            fábrica: 🔴 suena por los dos, 🟡 solo por navegador y ⚪ se queda
            solo en la campanita (no interrumpe nada). Si quieres afinar más,
            abre <strong>Urgencia por tipo de aviso (avanzado)</strong> y
            cambia el nivel de un tipo puntual — por ejemplo, que{" "}
            <strong>Asignación</strong> te suene 🔴 en vez de 🟡. El correo no
            entra en este ruteo; sigue el interruptor de arriba.
          </p>
          <p className="text-zinc-400 mt-2">
            <strong>Y cuando se escalan varios casos juntos:</strong> el aviso a
            tu navegador/Telegram sigue saliendo como un solo resumen (para no
            bombardearte), pero cada caso entra al resumen según{" "}
            <em>su</em> tipo: si bajaste <strong>Por quemarse</strong> a
            informativa, esos casos no van en el Telegram aunque en la misma
            corrida haya una escalación; el resumen del navegador y el de
            Telegram pueden traer distinto número de casos por eso.
          </p>
          <Captura
            src="/ayuda-img/perfil-ruteo.png"
            alt="Ruteo por nivel de urgencia y urgencia por tipo de aviso en Perfil"
            caption="Perfil → Notificaciones: por cada nivel (🔴/🟡/⚪) eliges si suena tu navegador y/o Telegram; abajo, la sección avanzada deja cambiar el nivel de un tipo de aviso en particular."
          />
        </div>

        <p className="text-zinc-400 mt-2">
          <strong>Horario de silencio</strong>: en Perfil → Notificaciones del
          navegador puedes definir una ventana (por ejemplo 8pm a 8am) en la
          que <strong>no</strong> te llegan avisos al celular ni a Telegram.
          Todo queda guardado en la campana de Alertas y, al terminar el
          horario, te llega un solo resumen de lo que pasó en la noche. Los
          recordatorios que tú programes sí suenan, como las alarmas del
          celular.
        </p>
        <p className="text-zinc-400 mt-2">
          <strong>Silenciar fines de semana y festivos</strong>: debajo del
          horario de silencio hay un interruptor (viene <strong>activado</strong>)
          que calla los avisos al celular y a Telegram los sábados, domingos y
          días feriados de México —incluida la escalación de casos y el resumen
          diario—. Todo queda en la campana de Alertas y, al volver el primer
          día hábil, te llega un solo resumen. Si trabajas en fin de semana,
          apágalo desde tu Perfil. Tus recordatorios sí suenan.
        </p>

        <div className="border-t border-ink-700 mt-3 pt-3">
          <p>
            <strong>Modo enfoque:</strong> el botón <strong>🎯</strong> (en la
            barra de arriba y también en Perfil → Notificaciones) silencia tu
            navegador y Telegram por <strong>30 minutos, 1 hora o 2 horas</strong>{" "}
            — para un rato de trabajo sin interrupciones, sin tener que apagar
            canales a mano. La campanita de Alertas{" "}
            <strong>sigue recibiendo todo</strong> mientras tanto, y tus{" "}
            <strong>recordatorios programados te avisan igual</strong> (como
            una alarma). Mientras está activo, el botón muestra la hora en que
            termina (por ejemplo 🎯 14:30); ábrelo para ver cuánto falta o
            terminarlo antes con <strong>Terminar</strong>. Al acabarse el
            tiempo —o al terminarlo tú— te llega un solo resumen de lo que se
            acumuló, igual que con el horario de silencio.
          </p>
          <Captura
            src="/ayuda-img/enfoque.png"
            alt="Modo enfoque activo, con el botón mostrando la hora y el panel para terminarlo"
            caption="Modo enfoque activo: el botón 🎯 de la barra muestra la hora en que termina; al abrirlo ves el detalle y el botón Terminar."
          />
        </div>

        <p className="text-zinc-400 mt-2">
          <strong>En computadora</strong>, el navegador (Chrome, Edge…) debe
          quedarse <strong>abierto</strong> —aunque sea minimizado— para
          recibir push; si lo cierras por completo, no llegan hasta que lo
          vuelves a abrir. En celular sí llegan con la app cerrada.
        </p>
        <p className="text-zinc-400 mt-2">
          En <strong>Perfil → Notificaciones → Mis equipos</strong>{" "}
          ves cada dispositivo dado de alta; puedes mandarle una{" "}
          <strong>prueba</strong> o <strong>quitarlo</strong>. Los marcados{" "}
          <em>sin confirmar</em> son navegadores que dejaron de escuchar:
          quítalos, o vuelve a activarlos desde ese mismo equipo.
        </p>
      </Section>

      <Section id="instalar" title="Instalar ArkTickets en tu celular">
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Android (Chrome)</strong>: menú ⋮ → "Agregar a pantalla
            principal" (o "Instalar app"). Queda con el icono de Emprenet.
          </li>
          <li>
            <strong>iPhone (Safari)</strong>: Compartir → "Agregar a pantalla
            de inicio". <strong>Importante</strong>: en iPhone las
            notificaciones push solo funcionan si abres ArkTickets desde ese
            icono (iOS 16.4 o más nuevo).
          </li>
        </ul>
      </Section>

      <Section id="recordatorios" title="Recordatorios">
        <p>
          En la pestaña <strong>Recordatorios</strong> de cada caso programa
          avisos: "en 10 minutos / 2 horas / 1 día" o una fecha exacta (mínimo
          5 minutos). El mensaje que escribes es lo que llega, por todas las
          vías: correo (sale del correo corporativo de quien lo creó), alerta
          en la app, push del navegador y Telegram.
        </p>
        <p className="mt-2 text-zinc-400">
          Por default va al dueño y al asignado del caso; puedes elegir otros
          usuarios o correos libres. El historial queda en la misma pestaña.
          Al cerrar el caso, sus recordatorios pendientes se cancelan solos
          —también los que todavía no avisaban—: un caso cerrado no avisa.
        </p>
        <p className="mt-2 text-zinc-400">
          En la <strong>bitácora</strong> del caso, la nota que originó el
          recordatorio trae un badge <strong>⏰</strong> con la fecha y hora
          programadas; si ya se cumplió o lo cancelaste, el badge se ve{" "}
          <span className="line-through">tachado</span>. Así ves el estado de
          un vistazo, sin entrar a la pestaña Recordatorios.
        </p>
      </Section>
    </>
  );
}
